import { createResource } from '../utils/resource'

const userStore = createResource('user', {})

export default userStore
